<span #label
    class="≈text-sm lg:≈text-base 2xl:≈text-lg ≈inline-block ≈leading-tight
        ≈font-normal ≈text-default-text ≈font-apple-system"
    [ngClass]="{
        '≈mb-2.5 sm:≈mb-3 md:≈mb-3.5 lg:≈mb-4 xl:≈mb-5': margin
    }">
    <ng-content>

    </ng-content>

    <ng-container *ngIf="helperText">

        <br>

        <div class="≈text-subdued-text ≈mt-2 ≈leading-tight">
            {{helperText}}
        </div>

    </ng-container>
</span>